import PromiseAction from './promiseAction';
const DEFAULT_OPTIONS = {
    interval: 500,
};
function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export class PromiseActionCreator {
    constructor({ config, responseMiddlewares, errorMiddlewares, }) {
        this.responseMiddlewares = [];
        this.errorMiddlewares = [];
        this.config = { ...DEFAULT_OPTIONS, ...config };
        this.responseMiddlewares = responseMiddlewares;
        this.errorMiddlewares = errorMiddlewares;
    }
    create(action) {
        return new PromiseAction((args) => new Promise(async (resolve, reject) => {
            let responses = [];
            let errors = [];
            let finished = false;
            const bag = {
                responses,
                errors,
                config: this.config,
                resolve: (r) => {
                    finished = true;
                    resolve(r);
                },
                reject: (e) => {
                    finished = true;
                    reject(e);
                },
            };
            while (!finished) {
                try {
                    const response = await action(args);
                    responses.push(response);
                    for (let middleware of this.responseMiddlewares) {
                        middleware(response, bag);
                        if (finished)
                            break;
                    }
                }
                catch (e) {
                    const error = e;
                    errors.push(error);
                    for (let middleware of this.errorMiddlewares) {
                        middleware(error, bag);
                        if (finished)
                            break;
                    }
                }
                await timeout(this.config.interval);
            }
        }));
    }
}
export default {
    configure: (args) => new PromiseActionCreator(args),
};
//# sourceMappingURL=data:application/json;base64,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